import { cn } from "@garther/ui/libs";
import * as React from "react";

export interface ISpinner extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  strokeWidth?: number;
}

const RADIUS = 45;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const Spinner = React.forwardRef<HTMLDivElement, ISpinner>(
  ({ className, label, strokeWidth = 8, ...props }, ref) => {
    return (
      <div ref={ref} {...props}>
        <div role="status">
          <svg
            aria-hidden="true"
            className={cn("w-8 h-8 animate-spin", className)}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="50"
              cy="50"
              r={RADIUS}
              stroke="currentColor"
              strokeWidth={strokeWidth}
              className="text-text-secondary"
            />
            <circle
              cx="50"
              cy="50"
              r={RADIUS}
              stroke="currentColor"
              strokeWidth={strokeWidth}
              strokeDasharray={`${CIRCUMFERENCE * 0.25} ${CIRCUMFERENCE * 0.75}`}
              strokeLinecap="round"
              className="text-text-primary"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
        {label && <div>{label}</div>}
      </div>
    );
  }
);
Spinner.displayName = "Spinner";

export { Spinner };
